module.exports = __webpack_public_path__ + "static/media/parceiro(2).39eeee95.png";